var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRejection = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00006H2V13.0001H8V14.0001H1V13.0001V2.00006V1.00006H13V2.00006V7.00006H12V2.00006ZM5 5.00006H10.999V4.00006H5V5.00006ZM3 5.00006V4.00006H4V5.00006H3ZM5 8.00006V7.00006H8V8.00006H5ZM3 8.00006V7.00006H4V8.00006H3ZM5 11.0001V10.0001H7V11.0001H5ZM10.5 9.79295L9.08579 8.37874L8.37868 9.08585L9.79289 10.5001L8.37868 11.9143L9.08579 12.6214L10.5 11.2072L11.9142 12.6214L12.6213 11.9143L11.2071 10.5001L12.6213 9.08585L11.9142 8.37874L10.5 9.79295ZM3 11.0001V10.0001H4V11.0001H3ZM10.5 6.00006C12.985 6.00006 15 8.01506 15 10.5001C15 12.9851 12.985 15.0001 10.5 15.0001C8.015 15.0001 6 12.9851 6 10.5001C6 8.01506 8.015 6.00006 10.5 6.00006Z",
    fill: "#BD271E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRejection, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rejection.e1a9e499.svg";
export { ForwardRef as ReactComponent };